import enLocale from 'element-ui/lib/locale/lang/en'
const en = { 
	messages:{
		//Customer.vue 
		customer_new :' Create ',
		customer_edit :' Edit ',
		customer_delete :' Delete ',
		customer_import :' Import ',
		customer_country :' Country/Region ',
		customer_city :' City ',
		customer_companyName :' Company name ',
		customer_search :' Search ',
		customer_webPage :' Home ',
		customer_email :' Email ',
		customer_phone :' Phone ',
		customer_address :' Address ',
		customer_language :' Language ',
		customer_personInCharge :' Person in charge ',
		customer_nature :' Enterprise property ',
		customer_remark :' Remarks ',
		customer_historyMask :' History task ',
		customer_customerInfo :' Client information ',
		customer_cancel :' Cancel ',
		customer_save :' Save ',
		customer_sure :' OK ',
		customer_deleteTip :' This action will permanently delete the potential client information. Do you want to continue? ',
		customer_customerRegion :' Client area ',
		customer_importFile :' Import files ',
		customer_browse :' Browse ',
		//Info.vue 
		info_basicInfo :' Basic information ',
		info_saleMan :' Number of marketing personnel ',
		info_potentialCustomer :' Number of potential clients ',
		info_sentMailCustomer :' Number of clients with sent email ',
		info_mailNum :' Total number of emails ',
		info_dialedPhone :' Number of dialed phones ',
		info_allPhone :' Total number of phones ',
		info_potentialCustomerStatus :' Potential client status ',
		info_noFeedback :' No feedback ',
		info_downLoaded :' Downloaded ',
		info_registered :' Registered ',
		info_activated :' Activated ',
		//Left.vue 
		left_index :' Home ',
		left_potentialCustomer :' Potential client ',
		left_saleMan :' Marketing personnel ',
		left_mask :' Task ',
		//Login.vue 
		login_email :' Email ',
		login_password :' Account password ',
		login_identifyCode :' Verification code ',
		login_forgetPassword :' Forgot your password? ',
		login_login :' Login ',
		login_mail :' Email address ',
		login_pass :' Password ',
		login_repass :' Re-enter password ',
		login_idenCode :' Verification code ',
		login_oldPass :' Old password ',
		login_resetCode :' Reset code ',
		login_inputMail :' Please enter the email ',
		login_inputPass :' Please enter the password ',
		login_inputIdenCode :' Please enter the verification code ',
		login_codeNeedSix :' Verification code should contain at least 6 digits! ',
		login_codeError :' Verification code is wrong! ',
		login_inputEmail :' Please enter the email ',
		//SalesPerson.vue 
		salesPerson_new :' Create ',
		salesPerson_detail :' Details ',
		salesPerson_delete :' Delete ',
		salesPerson_country :' Country/Region ',
		salesPerson_city :' City ',
		salesPerson_name :' Name ',
		salesPerson_whosCountry :' Responsible country/region ',
		salesPerson_whosCity :' Responsible city ',
		salesPerson_search :' Search ',
		salesPerson_phone :' Phone ',
		salesPerson_email :' Personal email ',
		salesPerson_olandEmail :' Oland email ',
		salesPerson_liveCountry :' Country/Region of residence ',
		salesPerson_livecity :' City of residence ',
		salesPerson_liveAddress :' Residential address ',
		salesPerson_motherLang :' Native language ',
		salesPerson_IDtype :' ID type ',
		salesPerson_IDnum :' ID number ',
		salesPerson_bank :' Bank ',
		salesPerson_bankAccount :' Bank account ',
		salesPerson_company :' Unit ',
		salesPerson_taskCount :' Number of tasks ',
		salesPerson_personalInfo :' Personal information ',
		salesPerson_IDnumber :' ID number ',
		salesPerson_address :' Address ',
		salesPerson_maskStatistic :' Total task ',
		salesPerson_maskCount :' Number of tasks ',
		salesPerson_potentitalcustomerStatusNum :' Number of potential client status: ',
		salesPerson_dialedPhone :' Number of dialed phones ',
		salesPerson_noFeedback :' No feedback ',
		salesPerson_downloaded :' Downloaded ',
		salesPerson_sentEmailNum :' Number of sent emails ',
		salesPerson_registered :' Registered ',
		salesPerson_activated :' Activated ',
		salesPerson_edit :' Edit ',
		salesPerson_cancel :' Cancel ',
		salesPerson_save :' Save ',
		salesPerson_sure :' OK ',
		salesPerson_deleteTip :' This operation will permanently delete his/her information. Do you want to continue? ',
		//Top.vue 
		top_img :' User image ',
		top_logOff :' Logout ',
	},
	...enLocale
}
export default en


// WEBPACK FOOTER //
// ./src/common/lang/en.js